module.exports = __webpack_public_path__ + "media/images/icons/since-badge-white-fr-f8d7bc886214fea860f3483b74cf2ce7.svg";